import { useState } from 'react';
import type { Analytics } from '../../application/analytics/analytics';

/**
 * Web Share API とリンクコピー。JS が動く環境でだけ現れる (X / LINE は静的リンクが常にある)。
 * 共有 URL は canonical そのもの。**追跡用の識別子を付けない** (UW-BLOG-07)。
 */
export function BlogShare({ articleId, canonical, title, analytics }: {
  articleId: string;
  canonical: string;
  title: string;
  analytics: Analytics;
}) {
  const [copied, setCopied] = useState(false);
  const canWebShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  const webShare = async () => {
    try {
      await navigator.share({ title, url: canonical });
      analytics.track({ name: 'web_blog_share', articleId, method: 'web_share' });
    } catch {
      // キャンセルは失敗ではない。何も出さない
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(canonical);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      analytics.track({ name: 'web_blog_share', articleId, method: 'copy' });
    } catch {
      // clipboard が使えない環境では黙って何もしない (X / LINE リンクが代替)
    }
  };

  return (
    <>
      {canWebShare && (
        <button type="button" className="btn btn--ghost btn--sm" onClick={() => void webShare()}>共有…</button>
      )}
      <button type="button" className="btn btn--ghost btn--sm" onClick={() => void copy()} aria-live="polite">
        {copied ? 'コピーしました' : 'リンクをコピー'}
      </button>
    </>
  );
}
